import mock from './mock'

export default mock



// WEBPACK FOOTER //
// ./src/mock/index.js